module.exports = __webpack_public_path__ + "img/reason_img1.1a2ed9ff.png";